import { Phone, Instagram, ArrowUpRight } from "lucide-react";
import { SITE, TikTokIcon } from "../lib/site";

export const Footer = () => (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0a0a0e]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-10">
                <div className="flex items-center gap-4">
                    <img src="/assets/logo-mark.png" alt="Pronto Auto Care" className="h-10 w-auto" />
                    <div>
                        <p className="font-display font-bold uppercase tracking-tight">Pronto Auto Care</p>
                        <p className="font-code text-[10px] uppercase tracking-[0.25em] text-zinc-500 mt-1">
                            Mobile Detailing — Miami, FL
                        </p>
                    </div>
                </div>

                <div className="flex flex-wrap items-center gap-3">
                    <a
                        data-testid="footer-phone-link"
                        href={SITE.phoneHref}
                        className="inline-flex items-center gap-2 border border-white/15 hover:border-white/50 transition-colors duration-300 rounded-full px-5 py-2.5 text-sm text-zinc-300"
                    >
                        <Phone className="w-4 h-4" /> {SITE.phoneDisplay}
                    </a>
                    <a
                        data-testid="footer-instagram-link"
                        href={SITE.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                        className="p-3 rounded-full border border-white/15 text-zinc-400 hover:text-white hover:border-white/50 transition-colors duration-300"
                    >
                        <Instagram className="w-4 h-4" />
                    </a>
                    <a
                        data-testid="footer-tiktok-link"
                        href={SITE.tiktok}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="TikTok"
                        className="p-3 rounded-full border border-white/15 text-zinc-400 hover:text-white hover:border-white/50 transition-colors duration-300"
                    >
                        <TikTokIcon className="w-4 h-4" />
                    </a>
                    <a
                        data-testid="footer-booksy-link"
                        href={SITE.booksy}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 bg-white text-black font-semibold rounded-full px-5 py-2.5 text-sm"
                    >
                        Book Now <ArrowUpRight className="w-4 h-4" />
                    </a>
                </div>
            </div>

            <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                <p className="text-xs text-zinc-600">© 2026 Pronto Auto Care. All rights reserved.</p>
                <p className="font-code text-[10px] uppercase tracking-[0.25em] text-zinc-600">
                    {SITE.area}
                </p>
            </div>
        </div>
    </footer>
);
